import { parseString } from 'xml2js';

// Webpack require.context to load all xml files in texts directory and subdirectories
const textContext = require.context('../texts', true, /\.xml$/);

/**
 * Resolves the raw content of an XML file based on requested language with graceful fallback.
 * @param {string} fileName - E.g. "1.xml", "guide.xml", "creation.xml"
 * @param {string} language - E.g. "en", "ja", "zh-TW", "zh-CN"
 * @returns {string|null} - Raw XML string content
 */
export function loadXmlRaw(fileName, language = 'en') {
  const keys = textContext.keys();

  // Clean filename so it doesn't have leading slash or path
  const baseName = fileName.replace(/^(\.\/|\/)/, '');

  const candidatePaths = [];

  if (language === 'zh-TW') {
    candidatePaths.push(`./zh-TW/${baseName}`);
    candidatePaths.push(`./zh-Hant/${baseName}`);
    candidatePaths.push(`./zh/${baseName}`);
  } else if (language === 'zh-CN') {
    candidatePaths.push(`./zh-CN/${baseName}`);
    candidatePaths.push(`./zh-Hans/${baseName}`);
    candidatePaths.push(`./zh/${baseName}`);
  } else if (language && language !== 'en') {
    candidatePaths.push(`./${language}/${baseName}`);
  }

  // English candidates and root fallback
  candidatePaths.push(`./en/${baseName}`);
  candidatePaths.push(`./${baseName}`);

  for (const path of candidatePaths) {
    if (keys.includes(path)) {
      const mod = textContext(path);
      return (mod && mod.default) ? mod.default : mod;
    }
  }

  return null;
}

/**
 * Loads and parses an XML file with language fallback.
 * @param {string} fileName - E.g. "1.xml", "guide.xml", "creation.xml"
 * @param {string} language - E.g. "en", "ja", "zh-TW", "zh-CN"
 * @param {function} callback - (err, result) => void
 */
export function loadAndParseXml(fileName, language, callback) {
  const rawXml = loadXmlRaw(fileName, language);
  if (!rawXml) {
    callback(new Error(`XML file not found: ${fileName} for language: ${language}`), null);
    return;
  }
  parseString(rawXml, callback);
}

export default loadAndParseXml;
